import textServices from 'services/text-services'
import F1Picture from './F1Picture'

// Prize cards (Figma 5595:12169/12173/12180): the CDN "-completo" exports
// bake shape, photo and copy into a single image per card, matching the
// frame exactly, so each card is one <img> (copy mirrored in alt).
const PRIZES = [
  {
    key: 'cuales_son',
    name: 'premios-cuales_son-completo',
    altKey: 'pitstops/prizes/altIntro',
    altFallback: '¿Cuáles son los premios?'
  },
  {
    key: 'grandstand',
    name: 'premios-grandstand-completo',
    altKey: 'pitstops/prizes/altGrandstand',
    altFallback: 'Gran premio final: 1 abono doble, Grandstand'
  },
  {
    key: 'foro_sol',
    name: 'premios-foro_sol-completo',
    altKey: 'pitstops/prizes/altForoSol',
    altFallback: 'Premios sorteables por Pit Stop: 20 abonos dobles, Foro Sol'
  }
] as const

const PrizesSection = () => {
  return (
    <div className="pitstops__prizes">
      {PRIZES.map(({ key, name, altKey, altFallback }) => (
        <F1Picture
          key={key}
          name={name}
          pictureClassName={`pitstops__prizes-card pitstops__prizes-card--${key}`}
          className="pitstops__prizes-media"
          alt={textServices.findByText(altKey, altFallback) as string}
        />
      ))}
    </div>
  )
}

export default PrizesSection
